import type { Team } from '@rhythmic/db/types'
import type { Collection } from '@tanstack/vue-db'
import { TEAM_TABLE } from '../../../collections/CollectionConfigurations'
import { useCollection } from '../../../composables/useCollection'

export function ensureTeamCollection(workspaceSlug: string) {
  return useCollection(TEAM_TABLE, {
    workspace_slug: workspaceSlug,
  }).collection as Collection<Team>
}

export function assertWorkspace(workspaceId?: string): asserts workspaceId is string {
  if (!workspaceId) throw new Error('Workspace context is not ready')
}

export function normaliseString(value?: string | null) {
  const trimmed = value?.trim()
  return trimmed && trimmed.length > 0 ? trimmed : undefined
}
